import "@/config/user-clarity";
import React from "react";
import ReactDOM from "react-dom/client";
import "vercel-toast/css";
import "./global.css";
import { Router } from "./router.tsx";
import "@/config/datadog-rum";
import "@/config/register-http-logging";
import { TraceProvider } from "@woba/logger-web/react";
import { wobaLogger } from "@/config/woba-logger";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <TraceProvider logger={wobaLogger}>
      <Router />
    </TraceProvider>
  </React.StrictMode>,
);
